/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';

export interface ISectionTitleProps {
    id: string;
    fontScale?: number;

    label?: string;
    subTitle?: string;
}

export const SectionTitle = ({
    id,
    label,
    subTitle,
    fontScale,
}: ISectionTitleProps) => {
    const _renderLabelIf = () => {
        if (label) {
            return (
                <>
                    <h5
                        key={`section-title-${id}`}
                        style={{
                            fontSize:
                                fontScale !== undefined
                                    ? `${18 + fontScale * 1.5}px`
                                    : '18px',
                        }}
                        className="mb-2 mt-4"
                    >
                        {label}
                    </h5>
                    {subTitle && <p> {subTitle} </p>}
                </>
            );
        }
        return null;
    };

    return <>{_renderLabelIf()}</>;
};

SectionTitle.defaultProps = {};
